<template>
  <div :class="formGroupClass" class="tangibles-form">
    <slot name="before"/>
    <input
      class="form-control"
      :id="tangiblesKey"
      :disabled="disabled"
      autocomplete="off"
      v-model="inputValue"
      @input="lengthFormatter($event.target.value)"
      @change="formatter($event.target.value)"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin';
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
import passSectionMixin from '@/common/mixins/application-form/passSectionMixin';

export default {
  name: 'TangiblesInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin
  ],

  methods: {
    lengthFormatter (value) {
      const match = /\.\d{2}(.*)/g.exec(value)
      if (match && match[1]) {
        value = value.substring(0, value.length - match[1].length)
      }

      this.inputValue = value
      this.$forceUpdate()
    },

    formatter (value) {
      let counter = value?.replace(/,/g, '.')
      counter = counter?.replace(/[^.,\d]/g, '')

      const match = counter?.match(/\d+\.?\d{1,2}/)
      if (match && match[0]) {
        counter = match[0]
      }

      this.inputValue = counter
    }
  },

  props: {
    inputLabel: {
      default: ''
    },

    inputName: {
      default: 'tangibles'
    },

    tangiblesId: {
      type: [Number],
      default: null
    }
  },

  computed: {
    tangiblesKey () {
      return `form-pass-tangibles-count-${this.tangiblesId}`
    },

    inputError () {
      return this.hasInputErrors ? 'Введите количество' : null
    },

    hasInputErrors () {
      return this.errors.application?.tangibles !== undefined &&
        this.errors.application?.tangibles[this.tangiblesId] &&
        this.errors.application?.tangibles[this.tangiblesId].find((err) => err === 'count')
    }
  }
}
</script>
